/* eslint react/prop-types: 0 */
import styled from '@emotion/styled';

import { useTranslation } from '@hotjar/translations';
import { Checkbox } from '@hotjar/webapp/components/Checkbox';
import { Tooltip } from '@hotjar/webapp/components/Tooltip';
import { weakKey } from '@hotjar/webapp/lib/weakKey';
import { removeAt } from '@hotjar/insights-common/lib/arrays';
import { Button } from '@hotjar/hotsauce';
import { QuestionOptionsContainer } from './components/QuestionOptionsContainer';
import { Answer } from './components/Answer';

const Actions = styled('div')`
  position: relative;
  margin-top: 10px;
  display: flex;
  align-items: center;
`;

const CheckboxContainer = styled('div')`
  display: inline-block;
  margin: 0 0 0 15px;
`;

const Checkboxes = styled.div`
  display: inline-block;
`;

const defaultProps = {
  onChange: () => {},
  randomizeAnswerOrder: false,
  pinLastToBottom: false,
};

export const Answers = ({
  answers,
  onChange,
  onAddAnswer,
  onDeleteAnswer,
  onRandomizeOrderChange,
  randomizeAnswerOrder,
  onPinLastToBottomChange,
  pinLastToBottom,
  validate,
  rtl,
}) => {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.questions.answer' });
  if (!answers || answers.length === 0) {
    return null;
  }

  const handleCommentClick = (index) => {
    const newAnswers = [...answers];
    newAnswers[index].comments = !newAnswers[index].comments;
    onChange(newAnswers);
  };

  const handleLabelChange = (value, index) => {
    const newAnswers = [...answers];
    newAnswers[index].text = value;
    onChange(newAnswers);
  };

  const handleAddAnswerClick = () => {
    onAddAnswer([...answers, { text: '', comments: false }]);
  };

  const handleDeleteAnswerClick = (removeAtIndex) => {
    const newAnswers = removeAt(answers, removeAtIndex);
    onDeleteAnswer(newAnswers, removeAtIndex);
  };

  const handleRandomizeOrderChange = (evt) => {
    onRandomizeOrderChange(evt.target.checked);
  };

  const handlePinLastToBottom = (evt) => {
    onPinLastToBottomChange(evt.target.checked);
  };

  return (
    <QuestionOptionsContainer>
      {answers.map((answer, index) => (
        <Answer
          key={weakKey(answer)}
          commentEnabled={answer.comments}
          counter={index + 1}
          hasError={validate && answer.text.length === 0}
          onCommentClick={() => handleCommentClick(index)}
          onDeleteClick={() => handleDeleteAnswerClick(index)}
          onTextChange={(evt) => handleLabelChange(evt.target.value, index)}
          showDelete={answers.length > 2}
          text={answer.text}
          rtl={rtl}
        />
      ))}
      <Actions>
        <Button size="s" kind="secondary" onClick={handleAddAnswerClick}>
          {t('add-answer')}
        </Button>
        <Checkboxes>
          <Tooltip content={t('randomize-order-tooltip')}>
            <CheckboxContainer>
              <Checkbox
                checked={randomizeAnswerOrder}
                onChange={handleRandomizeOrderChange}
                size="s"
              >
                {t('randomize-order')}
              </Checkbox>
            </CheckboxContainer>
          </Tooltip>
          {randomizeAnswerOrder && (
            <CheckboxContainer>
              <Checkbox checked={pinLastToBottom} onChange={handlePinLastToBottom} size="s">
                {t('pin-last-answer', { answerNumber: answers.length })}
              </Checkbox>
            </CheckboxContainer>
          )}
        </Checkboxes>
      </Actions>
    </QuestionOptionsContainer>
  );
};

Answers.defaultProps = defaultProps;
